import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { ChevronsUpDown } from "lucide-react";
import { ButtonHTMLAttributes, forwardRef, ReactNode } from "react";

export interface TriggerButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  buttonLabel?: ReactNode;
  placeholder?: string;
}

const TriggerButton = forwardRef<HTMLButtonElement, TriggerButtonProps>(
  ({ buttonLabel, placeholder, disabled, className, ...rest }, ref) => (
    <Button
      ref={ref}
      variant="outline"
      className={cn("justify-between", className)}
      disabled={disabled}
      {...rest}
    >
      <span className="grid grid-cols-[auto_1fr] items-center flex-grow">
        {buttonLabel ? (
          <span className="block truncate">{buttonLabel}</span>
        ) : (
          <span className="block truncate text-slate-500">{placeholder}</span>
        )}
        <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50 justify-self-end" />
      </span>
    </Button>
  ),
);
TriggerButton.displayName = "TriggerButton";

export default TriggerButton;
